export function getScoreBadgeVariant(
  score: number | null | undefined
): "success" | "error" | "warning" | "default" {
  if (score === null || score === undefined) return "default";
  if (score >= 0.7) return "success";
  if (score >= 0.4) return "warning";
  return "error";
}

export function getScoreColor(score: number | null | undefined): string {
  if (score === null || score === undefined) return "#6b7280";
  if (score >= 0.7) return "#10b981";
  if (score >= 0.4) return "#f59e0b";
  return "#ef4444";
}

export function getScoreBackgroundColor(score: number | null | undefined): string {
  const color = getScoreColor(score);
  const rgb = color.replace("#", "");
  const r = parseInt(rgb.substring(0, 2), 16);
  const g = parseInt(rgb.substring(2, 4), 16);
  const b = parseInt(rgb.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, 0.1)`;
}

export function getScoreBorderColor(score: number | null | undefined): string {
  const color = getScoreColor(score);
  const rgb = color.replace("#", "");
  const r = parseInt(rgb.substring(0, 2), 16);
  const g = parseInt(rgb.substring(2, 4), 16);
  const b = parseInt(rgb.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, 0.3)`;
}

export function getStatusBadgeVariant(
  statusCode: number
): "success" | "error" | "warning" {
  if (statusCode >= 200 && statusCode < 300) return "success";
  if (statusCode >= 400 && statusCode < 500) return "error";
  return "warning";
}
